import { Tooltip, TooltipProps } from "@mui/material";
import { useIsStorybook } from "utils/customHooks/storyHooks";

/** Tooltips don't cooperate with Storybook snapshots, so in Storybook we just render a fragment instead */
export function useTooltipStorybookFriendly() {
  const isStorybook = useIsStorybook();
  return isStorybook // Tooltip doesn't cooperate with storyshots
    ? ({ children: tooltipChildren, ...rest }) => <>{tooltipChildren}</> // so return a fragment instead
    : Tooltip;
}

/** Tooltips don't cooperate with Storybook snapshots, so in Storybook we just render a fragment instead */
export function TooltipStorybookFriendly({
  children: tooltipChildren,
  title,
  ...rest
}: {
  children: any;
  title: string;
} & TooltipProps) {
  const isStorybook = useIsStorybook();
  return isStorybook ? ( // Tooltip doesn't cooperate with storyshots
    <>{tooltipChildren}</> // so return a fragment instead
  ) : (
    <Tooltip title={title} {...rest}>
      {tooltipChildren}
    </Tooltip>
  );
}
